export default __webpack_public_path__ + "static/media/mg-white.96984b6a.svg";